/**
 * Dispatches an event 'bk-start-loading' that can be listened to.
 *
 * @param element the html element that dispatches the event. The default value is <code>document</code> if no parameter is given.
 */
export const dispatchStartLoadingEvent = (element = document) => {
    element.dispatchEvent(
        new CustomEvent('bk-start-loading', {
            bubbles: true,
        }),
    );
};

/**
 * Dispatches an event 'bk-stop-loading' that can be listened to.
 *
 * @param element the html element that dispatches the event. The default value is <code>document</code> if no parameter is given.
 */
export const dispatchStopLoadingEvent = (element = document) => {
    element.dispatchEvent(new CustomEvent('bk-stop-loading', { bubbles: true }));
};
